import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromState from './lastplayers.state';

const { selectIds, selectEntities, selectAll, selectTotal } =
  fromState.adapter.getSelectors();

export const selectLastplayersState =
  createFeatureSelector<fromState.LastplayersState>(
    fromState.lastplayersEntityKey,
  );

export const selectLastplayersIds = createSelector(
  selectLastplayersState,
  selectIds,
);

export const selectLastplayersEntities = createSelector(
  selectLastplayersState,
  selectEntities,
);

export const selectAllLastplayersItemsPresent = createSelector(
  selectLastplayersState,
  selectAll,
);

export const selectLastplayersItemsPresentCount = createSelector(
  selectLastplayersState,
  selectTotal,
);

export const selectLastplayersByRoom = (room: string) =>
  createSelector(
    selectAllLastplayersItemsPresent,
    (entries: fromState.LastplayersEntity[]) => {
      return entries.filter((entry) => entry.data);
    },
  );
